<template>
  <div class="activities">
    <div class="title">
      <div></div>
      用户列表
    </div>
    <div class="query">
      <div class="query-box">
        <span>查询</span>
        <el-input v-model="query" placeholder="用户名称/手机号"></el-input>
      </div>
       <div class="query-box">
        <el-select v-model="type" placeholder="请选择类型">
          <el-option label="全部" value="">全部</el-option>
          <el-option label="酒吧老板" value="1">酒吧老板</el-option>
          <el-option label="普通用户" value="2">普通用户</el-option>
          <el-option label="付费用户" value="3">付费用户</el-option>
        </el-select>
      </div>
      <el-button type="primary" @click="inquire">查询</el-button>
      <el-button type="primary" @click="derive">导出</el-button>
    </div>
    <div class="activities-main">
      <el-table :data="tableData" border style="width: 100%">
        <el-table-column align="center" type="index" label="序号" width="50">
        </el-table-column>
        <el-table-column align="center" prop="headImages" label="头像">
         <template slot-scope="images">
            <el-image
            style="width: 50px; height: 50px"
              class="table-td-thumb"
              :src="images.row.headImages"
              :preview-src-list="[images.row.headImages]"
            ></el-image>
          </template>
        </el-table-column>
        <el-table-column align="center" prop="nickName" label="用户昵称">
        </el-table-column>
      
        <el-table-column align="center" prop="" label="用户角色">
            <template slot-scope="scope">
                  <div :class="scope.row.role==1?'':scope.row.role==2?'active':'active2'">
                    {{scope.row.role==1?'普通用户':scope.row.role==2?'付费用户':"酒吧老板"}}
                  </div>

               
              </template>
        </el-table-column>
            <el-table-column align="center" prop="isVip" label="会员状态">
            <template slot-scope="scope">
                  <div :class="scope.row.isVip==true?'active2':'active'">
                    {{scope.row.isVip==true?'会员':"非会员"}}
                  </div>

               
              </template>
        </el-table-column>
        <el-table-column align="center" prop="positionInfo" label="地址">
        </el-table-column>
          <el-table-column align="center" prop="type" label="购买方式">
          <template slot-scope="scope">
            <div :class="scope.row.type == 1 ? 'active2' :scope.row.type == 2 ? 'active':''">
              {{ scope.row.type == 1 ? "购买" :scope.row.type == 2?"赠送":"" }}
            </div>
          </template>
        </el-table-column>

        <el-table-column align="center" prop="phone" label="手机号">
        </el-table-column>

          <el-table-column align="center" prop="createTime" label="注册时间">
        </el-table-column>

        
         <el-table-column align="center" label="操作" width="240">
          <template slot-scope="scope">
            <el-button
              size="mini"
              type="success"
              @click="setVipButton(scope.row.id)"
              v-if="scope.row.isVip==false"
              >设置会员</el-button>
              <el-button
              size="mini"
              type="danger"
              @click="cancelVipBut(scope.row.id)"
              v-else
              >取消会员</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!-- 分页 -->
    <div class="paging">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10, 20, 30, 50]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
import local from '@/utils/local.js'
import {webUserPage,setVip,cancelVip,functiondownload} from "@/api/api"
export default {
  data() {
    return {
          //  activityId: "",
      ruleList: [],
      query: "",
      total: 0,
      currentPage: 1,
      pageSize: 10,
      tableData: [],
      adminId:'',
      type:''
  
    };
  },
  created () {
      this.adminId=local.get('id')
     this.getList();
  },
  methods: {
    // 导出
    derive(){
       functiondownload('/web/user/webUserPageExportExcel',{ query:this.query, type:this.type,},true)
    },
    // 设置会员
    setVipButton(id) {
      this.$confirm("将设置该用户为会员, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          let res = await setVip({
            userId: id,
          });
          if (res.code == 200) {
            this.$message({
              type: "success",
              message: "设置成功!",
            });
            this.getList();
          }
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消",
          });
        });
    },

     // 设置会员
    cancelVipBut(id) {
      this.$confirm("将取消该用户会员, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          let res = await cancelVip({
            userId: id,
          });
          if (res.code == 200) {
            this.$message({
              type: "success",
              message: "设置成功!",
            });
            this.getList();
          }
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消",
          });
        });
    },
        
  //  获取用户列表
     async getList(){
        let res=await webUserPage({
             query:this.query,
             type:this.type,
            pageSize:this.pageSize,
            pageNum:this.currentPage
        })
        console.log(res)
            let {data}=res
      //边界判断
      if (!data.itemList.length && this.currentPage !== 1) {
        this.currentPage -= 1;
        this.getList();
      }
        this.tableData=data.itemList
		console.log(this.tableData,9898)
        this.total=data.totalSize
     },
       // 查询
    inquire(){       
        this.getList();
    },
      // 刷新
    refresh(){
      this.query=''
        this.getList();
    },

      open() {
        const h = this.$createElement;
        this.$msgbox({
          title: '消息',
          message: h('p', null, [
            h('span', null, '内容可以是 '),
            h('i', { style: 'color: teal' }, 'VNode')
          ]),
          showCancelButton: true,
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          beforeClose: (action, instance, done) => {
            if (action === 'confirm') {
              instance.confirmButtonLoading = true;
              instance.confirmButtonText = '执行中...';
              setTimeout(() => {
                done();
                setTimeout(() => {
                  instance.confirmButtonLoading = false;
                }, 300);
              }, 3000);
            } else {
              done();
            }
          }
        }).then(action => {
          this.$message({
            type: 'info',
            message: 'action: ' + action
          });
        });
      },
       //每页多少条
    handleSizeChange(val) {
      this.pageSize = val;
      this.getList();
    },
    //当前多少页
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getList();
    },
  },
};

</script>

<style lang="less" scoped>
.activities {
  // height: 100%;
  background: #fff;
  padding: 15px;
  color: #303133;
  .title {
    display: flex;
    align-items: center;
    font-size: 16px;
    font-weight: 700;
    div {
      width: 3px;
      height: 16px;
      background: #409eff;
      margin-right: 10px;
    }
  }
  .query {
    margin: 15px 0 30px;
    display: flex;
    align-items: center;
    .query-box {
      display: flex;
      align-items: center;
      margin-right: 20px;
      .el-input {
        width: 260px;
      }
      span {
        width: 60px;
      }
    }
  }
  .activities-main {
    margin: 15px 0;
  }
  .paging {
    display: flex;
    justify-content: flex-end;
  }
}
.active{
  color: #d1941d;
}
.active2{
  color: #33b959;
}
</style>